import type { Metric } from 'web-vitals';
import { onCLS,onFCP,onINP,onLCP,onTTFB } from 'web-vitals';

type ReportHandler = (metric: Metric) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler): void => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    onCLS(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
    onINP(onPerfEntry); // substituto moderno de onFID
  }
};

export default reportWebVitals;
